<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'vendorManagementDashboard' }">
              {{ $t('companyFormAdminView.vendorManagement') }}
            </router-link>
          </li>
          <li class="breadcrumb-item">
            {{ $t('vendorManagementBlacklist.qaraSiyah') }}
          </li>
        </ol>
      </div>
      <h4 class="my-3">
        {{ $t('vendorManagementBlacklist.qaraSiyah') }}
      </h4>

      <div class="mb-3">
        {{ $t('vendorManagementBlacklist.sizIrktinizinQaydalarnaUyunHrHansBirTkilatQaraSiya') }}
      </div>
    </div>

    <!-- Blacklist Section -->
    <div class="card mb-4">
      <div class="card-header">
        <h5>{{ $t('vendorManagementBlacklist.qaraSiyah') }}</h5>
      </div>
      <div class="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t('companyProfile.ven') }}</th>
              <th>{{ $t('companyPage.irkt') }}</th>
              <th>{{ $t('request.sbb') }}</th>
              <th>-</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="b in blackList"
              :key="b.taxId"
            >
              <td>{{ b.taxId }}</td>
              <td>
                <span v-if="b.blacklistedCompanyName">{{ b.blacklistedCompanyName }}</span>
                <span
                  v-else
                  style="color: #b6b6b6"
                >{{ $t('vendorManagementBlacklist.hazirdaSistemdMvcudDeyil') }}</span>
              </td>
              <td>{{ b.reason }}</td>
              <td>
                <a
                  href="#"
                  class="mr-3"
                  @click.prevent="editBlacklist(b.id, b.reason)"
                >
                  <feather
                    type="edit-3"
                    class="text-primary"
                  />
                </a>
                <a
                  href="#"
                  @click.prevent="deleteBlacklist(b.taxId)"
                >
                  <feather
                    type="trash"
                    class="text-danger"
                  />
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="my-3">
          <button
            v-b-modal.modal_blacklist_create
            class="btn btn-sm btn-dark"
          >
            {{ $t('vendorManagementBlacklist.lavEt') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Deleted Vendors Section -->
    <div class="card">
      <div class="card-header">
        <h5>{{ $t('vendorManagementDeleted.deletedVendorsTitle') }}</h5>
      </div>
      <div class="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t('companyProfile.ven') }}</th>
              <th>{{ $t('companyPage.irkt') }}</th>
              <th>{{ $t('request.sbb') }}</th>
              <th>-</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="d in deletedVendors"
              :key="d.taxId"
            >
              <td>{{ d.taxId }}</td>
              <td>
                <span v-if="d.deletedCompanyName">{{ d.deletedCompanyName }}</span>
                <span
                  v-else
                  style="color: #b6b6b6"
                >{{ $t('vendorManagementDeleted.hazirdaSistemdMvcudDeyil') }}</span>
              </td>
              <td>{{ d.reason }}</td>
              <td>
                <a
                  href="#"
                  class="mr-3"
                  @click.prevent="editDeletedVendor(d.id, d.reason)"
                >
                  <feather
                    type="edit-3"
                    class="text-primary"
                  />
                </a>
                <a
                  href="#"
                  @click.prevent="deleteDeletedVendor(d.taxId)"
                >
                  <feather
                    type="trash"
                    class="text-danger"
                  />
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="my-3">

        </div>
      </div>
    </div>

    <!-- Modals for Blacklist and Deleted Vendors -->
    <b-modal
      id="modal_blacklist_create"
      centered
      :title="$t('vendorManagementBlacklist.qaraSiyahyaIrktLavEt')"
      class="theme-modal"
      :hide-footer="true"
    >
      <form @submit.prevent="addBlacklist">
        <div class="mb-3">
          <label>{{ $t('companyProfile.ven') }}</label>
          <div>
            <input
              v-model.trim.number="newBlacklist.taxId"
              type="number"
              class="form-control"
              required
            >
          </div>
        </div>
        <div class="mb-3">
          <label>{{ $t('request.sbb') }}</label>
          <div>
            <textarea
              v-model.trim="newBlacklist.reason"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-success"
          >
            {{ $t('request.lavEt') }}
          </button>
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from "vuex";
import { mediaBase } from "@/repositories/Repository";
import {
  addBlacklist,
  getBlacklist,
  removeBlacklist,
  updateBlacklist,
  getDeletedVendors,
  deleteDeletedVendor,
  updateDeletedVendor,
  handleErrors
} from "@/repositories/VendorManagementRepository";

export default {
  data() {
    return {
      mediaBase: mediaBase,
      blackList: [],
      deletedVendors: [],

      newBlacklist: {
        taxId: '',
        reason: ''
      },
      newDeletedVendor: {
        taxId: '',
        reason: ''
      }
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user
    })
  },
  mounted() {
    this.getBlacklistData();
    this.getDeletedVendorsData();
  },
  methods: {
    getBlacklistData() {
      getBlacklist(this.token).then((list) => {
        this.blackList = list;
      });
    },
    getDeletedVendorsData() {
      getDeletedVendors(this.token).then((list) => {
        this.deletedVendors = list;
      });
    },
    addBlacklist() {
      addBlacklist(this.token, this.newBlacklist.taxId, this.newBlacklist.reason).then((data) => {
        if (data.code === 200) {
          this.getBlacklistData();
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: data.companyRegistered ? this.$t("elvaEdld") : this.$t("buVOENSyhyElvEdldLknbVnHzrd"),
            icon: 'success'
          });
          this.newBlacklist.taxId = '';
          this.newBlacklist.reason = '';
          this.$bvModal.hide("modal_blacklist_create");
        } else if (data.code === 409) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("buShrtArtqElvEdlb"),
            icon: 'warning'
          });
        } else if (data.code === 403) {
          this.$swal({
            title: this.$t("generalModal.errorTitle"),
            text: this.$t("vendorManagementBlacklist.noPermissionToAddBlacklist"),
            icon: 'error'
          });
        } else {
          handleErrors(this.$swal, data, null);
        }
      });
    },
    deleteBlacklist(taxId) {
      this.$swal({
        title: this.$t("general.dltConfirm"),
        text: this.$t("buSrktArtqSznSrktnzPrtl"),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          removeBlacklist(this.token, taxId).then((data) => {
            if (data.code === 200) {
              this.getBlacklistData();
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("generalModal.deleted"),
                icon: "success"
              });
            } else if (data.code === 403) {
              this.$swal({
                title: this.$t("generalModal.errorTitle"),
                text: this.$t("vendorManagementBlacklist.noPermissionToRemoveBlacklist"),
                icon: "error"
              });
            } else {
              handleErrors(this.$swal, data, null);
            }
          });
        }
      });
    },
    deleteDeletedVendor(taxId) {
      this.$swal({
        title: `${this.$t("general.dltConfirm")} ${this.$t("vendorManagementDeleted.confirmWord")}`,
        text: this.$t("deletedVendorDelete"),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          deleteDeletedVendor(this.token, taxId).then((data) => {
            if (data.code === 200) {
              this.getDeletedVendorsData();
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("generalModal.deleted"),
                icon: "success"
              });
            } else if (data.code === 403) {
              this.$swal({
                title: this.$t("generalModal.errorTitle"),
                text: this.$t("vendorManagementBlacklist.noPermissionToDeleteDeletedVendor"),
                icon: "error"
              });
            } else {
              handleErrors(this.$swal, data, null);
            }
          });
        }
      });
    },
    editBlacklist(id, reason) {
      this.$swal({
        title: this.$t("sbbQydEdn"),
        icon: "question",
        input: "textarea",
        inputValue: reason,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("sectorSelectionModal.yaddaSaxla"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          updateBlacklist(this.token, id, result.value).then((data) => {
            if (data.code === 200) {
              this.getBlacklistData();
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("sbbYnlnd"),
                icon: "success"
              });
            } else {
              handleErrors(this.$swal, data, null);
            }
          });
        }
      });
    },
    editDeletedVendor(id, reason) {
      this.$swal({
        title: this.$t("sbbQydEdn"),
        icon: "question",
        input: "textarea",
        inputValue: reason,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("sectorSelectionModal.yaddaSaxla"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          updateDeletedVendor(this.token, id, result.value).then((data) => {
            if (data.code === 200) {
              this.getDeletedVendorsData();
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("sbbYnlnd"),
                icon: "success"
              });
            } else {
              handleErrors(this.$swal, data, null);
            }
          });
        }
      });
    }
  }
};
</script>
